import React, { useContext, useEffect } from 'react';

import { nanoid } from '@reduxjs/toolkit';
import { CollectionContext } from '../context';

import { MediaLibraryChooser } from '../../../../components/mediaLibrary';
import { MediaLibrary } from '../../../../types/mediaLibrary';
import { CollectionEditState } from '../../../../types/collections';
import { MediaFile } from '../../../../types/media';

import styles from './banner.module.scss';
import { useCollectionsAdoption } from 'src/redux/actions/adoption/collection';

interface BannerEditorProps {
  collection: CollectionEditState;
}

const BannerEditor: React.FC<BannerEditorProps> = ({ collection }) => {
  const collectionContext = useContext(CollectionContext);

  const { trackBannerContentSelected, trackBannerScreenView } = useCollectionsAdoption();

  useEffect(() => {
    trackBannerScreenView();
  }, []);

  const handleFileChange = (background: MediaFile) => {
    let banner = collection.banner;
    if(!banner) {
      banner = {
        position: 'top',
        autoHeightEnabled: true,
        sharedByEnabled: true,
      };
    }

    collectionContext.updateCollectionProperty('banner', {
      ...banner,
      background: background,
      crop: null,
    });

    trackBannerContentSelected({
      collection: collection,
      media: background,
    });
  }

  const handleBannerSelection = (media: MediaLibrary) => {
    if (!media) {
      return;
    }

    const imageUrl = media.imageUrl;
    if(!imageUrl) {
      return;
    }

    fetch(imageUrl)
    .then((response) => {
      return response.blob();
    })
    .then(blob => {
      const url = URL.createObjectURL(blob);

      const backgroundMedia = {
        id: nanoid(6),
        entityType: 'media-preview',
        type: media.mediaType,
        full: url,
        thumbnail: url,
        width: media.width,
        height: media.height,
        contentType: blob.type,
      } as MediaFile
    
      handleFileChange(backgroundMedia);
    }).catch(error => {
      console.error(error);
    });
  }

  return (
    <div className={styles.bannerChooser}>
      <MediaLibraryChooser entityType="collection" onChange={handleBannerSelection} columns={5}/>
    </div>
  );
}

export { BannerEditor };